module.exports = __webpack_public_path__ + "img/Weight.1c9ff279.svg";